import clsx from "clsx";
import { View } from ".";

type SettingsListProps = {
  children: React.ReactNode;
  className?: string;
};

export const SettingsList = ({ children, className }: SettingsListProps) => {
  return <View className={clsx("grid grid-cols-1 gap-4", className)}>{children}</View>;
};
